// extracted by mini-css-extract-plugin
export default {"container":"Gq-z","brandName":"Hq-z","productName":"Iq-z","productNamePdpEnhancements":"Jq-z","breakLongProductName":"Kq-z"};